import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase/app'
import {firestoreAction, vuexfireMutations} from 'vuexfire'
import {EUserType} from "@/types";
import router from "@/router";

Vue.use(Vuex)

interface Iuser {
    announcements?: any[]
    tipologia?: EUserType
}

export interface RootState {
    user?: Iuser
    authUser?: any
    announcements: any[],
    workers: any[],
    companies: any[],
    allAnnouncements: any[],
}


export default new Vuex.Store<RootState>({
    state: {
        user: undefined,
        authUser: undefined,
        announcements: [],
        workers: [],
        companies: [],
        allAnnouncements: [],
    },
    mutations: {
        setUser(state, payload) {
            state.authUser = payload
        },
        ...vuexfireMutations,
    },
    actions: {
        setUserRef: firestoreAction(({bindFirestoreRef, unbindFirestoreRef}, ref) => {
                if (ref) {
                    return bindFirestoreRef('user', ref, {wait: true})
                } else {
                    return unbindFirestoreRef('user')
                }
            }
        ),
        setAnnouncementsRef: firestoreAction(({bindFirestoreRef, unbindFirestoreRef}, ref) => {
                if (ref) {
                    return bindFirestoreRef('announcements', ref, {wait: true})
                } else {
                    return unbindFirestoreRef('announcements')
                }
            }
        ),
        setWorkersRef: firestoreAction(({bindFirestoreRef, unbindFirestoreRef}, ref) => {
                if (ref) {
                    return bindFirestoreRef('workers', ref, {wait: true})
                } else {
                    return unbindFirestoreRef('workers')
                }
            }
        ),
        setCompaniesRef: firestoreAction(({bindFirestoreRef, unbindFirestoreRef}, ref) => {
                if (ref) {
                    return bindFirestoreRef('companies', ref, {wait: true})
                } else {
                    return unbindFirestoreRef('companies')
                }
            }
        ),
        setAllAnnouncementsRef: firestoreAction(({bindFirestoreRef, unbindFirestoreRef, state}, ref) => {
                if (ref) {
                    return bindFirestoreRef('allAnnouncements', ref, {
                        wait: true, serialize: (doc) => {
                            let res = Object.defineProperty(doc.data() || {}, 'id', {value: doc.id});

                            res['company'] = state.companies.find((company) => {
                                return company.id == doc.ref.parent?.parent?.id
                            })
                            return res
                        }
                    })
                } else {
                    return unbindFirestoreRef('allAnnouncements')
                }
            }
        ),
        setProfileRefs({commit, dispatch, state}){
            if (state.user?.tipologia == EUserType.Company) {
                return dispatch('setWorkersRef', firebase.firestore()
                    .collection('users').where('tipologia', '==', EUserType.Worker)
                    .orderBy('nome', 'asc').orderBy('cognome', 'asc'))
            }
            if (state.user?.tipologia == EUserType.Worker) {

                return new Promise((resolve, reject) => {
                    dispatch('setCompaniesRef', firebase.firestore()
                        .collection('users').where('tipologia', '==', EUserType.Company)
                        .orderBy('nome_ragione_sociale', 'asc')).then(() => {
                        dispatch('setAllAnnouncementsRef', firebase.firestore().collectionGroup('announcements'))
                            .then(resolve).catch(reject)
                    }).catch(reject)
                });


            }
        },
        autoSignIn({commit, dispatch, state}, payload) {
            return new Promise((resolve, reject) => {
                commit('setUser', {
                    id: payload.uid,
                    name: payload.displayName,
                    email: payload.email,
                    photoUrl: payload.photoURL,
                    emailVerified: payload.emailVerified,
                    phoneNumber: payload.phoneNumber
                })
                if (payload.uid) {
                    let p = new Promise((resolve, reject) => {
                        dispatch('setUserRef', firebase.firestore()
                            .collection('users')
                            .doc(payload.uid)).then(() => {
                             dispatch('setProfileRefs').then(resolve).catch(reject)
                        })
                    })
                    let derefs = [
                        p,
                        dispatch('setAnnouncementsRef', firebase.firestore()
                            .collection('users')
                            .doc(payload.uid).collection('announcements'))
                    ]
                    Promise.all(derefs).then(resolve).catch(reject)
                } else {
                    resolve(payload);
                }
            });
        },
        signInWithEmailAndPassword({commit, dispatch}, {email, password}) {
            return firebase.auth().signInWithEmailAndPassword(email, password);
        },
        signInWithEmailLink({commit, dispatch}, {email}) {

            return firebase.auth().signInWithEmailLink(email as string, window.location.href)
                .then((result) => {
                    window.localStorage.removeItem('emailForSignIn');
                    dispatch('autoSignIn', result)
                })
                .catch((error) => {
                    console.log(error)
                });
        },
        signOut({commit, dispatch}) {
            return new Promise((resolve, reject) => {
                firebase.auth().signOut()
                    .then((response) => {
                        commit('setUser', null)
                        Promise.all([
                            dispatch('setUserRef', null),
                            dispatch('setAnnouncementsRef', null),
                            dispatch('setAllAnnouncementsRef', null),
                            dispatch('setWorkersRef', null),
                            dispatch('setCompaniesRef', null)
                        ])
                            .then(resolve).catch(reject)
                        router.push('/');
                    })
                    .catch(reject)
            })

        },
        createUserWithEmailAndPassword({commit, dispatch}, {email, password}) {
            return firebase.auth().createUserWithEmailAndPassword(email, password);
        },
        signInWithPhoneNumber({commit}, {phoneNumber, appVerifier}) {
            return firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier);
        },
    },
    modules: {},
    getters: {
        user(state) {
            return state.authUser
        },
        profile(state) {
            return state.user
        },
        announcements(state) {
            return state.announcements || []
        },
        workers(state) {
            return state.workers || []
        },
        companies(state) {
            return state.companies || []
        },
        allAnnouncements(state) {
            return state.allAnnouncements || []
        },
        isWorker(state) {
            return state.user?.tipologia === EUserType.Worker
        },
        isCompany(state) {
            return state.user?.tipologia === EUserType.Company
        },
    }
})
